import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@environments/environment';
import { ResponseService } from '../../_models';

@Injectable({
  providedIn: 'root'
})
export class PermissionManagerService {
  public respuestaGenerica: ResponseService;

  constructor(private http: HttpClient) { }

  public getPermissions(typePermission: string){
    return this.http.get(`${environment.apiUrl}${environment.getPermissions}${typePermission}`);
  }
}
